import styled from 'styled-components'
import PropTypes from 'prop-types'

import { Columns } from './columns'

const gridArea = 'cnt'
const Wrap = styled.div`
  grid-area: ${gridArea};
  background-color: ${({ bgColor }) => bgColor};
`
const Content = ({ children, bgColor = 'transparent', ...rest }) => {
  return (
    <Wrap bgColor={bgColor} {...rest}>
      {children}
    </Wrap>
  )
}

Content.propTypes = {
  bgColor: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.shape({
      type: PropTypes.oneOf([Columns])
    }),
    PropTypes.arrayOf(
      PropTypes.node,
      PropTypes.oneOfType([
        PropTypes.shape({
          type: PropTypes.oneOf([Columns])
        })
      ])
    )
  ]).isRequired
}
Content.slotName = 'PageContent'

export { Content, gridArea }
